import { render, staticRenderFns } from "./senior-list.vue?vue&type=template&id=0f5c1780&scoped=true&"
import script from "./senior-list.vue?vue&type=script&lang=js&"
export * from "./senior-list.vue?vue&type=script&lang=js&"
import style0 from "./senior-list.vue?vue&type=style&index=0&id=0f5c1780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c1780",
  null
  
)

export default component.exports